<template>
    <div class="scoped-rich-text-editor-content-display" v-html="urlify(text)">
      
    </div> 
    <!-- <iframe class="scoped-rich-text-editor-content-display" style="width:100%; border:none" :srcdoc="urlify(text)"></iframe> -->

</template>
<script>
    // import suneditorCss from 'node_modules/suneditor/dist/css/suneditor.min.css?raw';
    import {mapGetters} from 'vuex';
    export default{
        name: "DisplayRichTextEditorContent",
        props:{
            text:{
                type: String,
                default(){
                    return "";
                }
            }
        },
        methods:{
          urlify(text) {
            if(text != undefined && text != null && text != ""){
                //text = text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g,'&gt;')
                var mentionsRegex = /\B@[a-z0-9_-]+/gi;
                let that = this;
                text = text.replace(mentionsRegex,function(mention){
                    let temp = mention.substr(1);
                    if(temp == that.getLoggedInUser()){
                        return '<span style="border-radius: 15px;padding: 3px 7px;background: #007373c9;color: #eee;">' + mention + '</span>';
                    }else{
                        return '<span style="border-radius: 15px;background: transparent;color: #2cbdbd;">' + mention + '</span>';
                    }
                })
                var urlRegex = /(?<!href=["'])(https?:\/\/[^\s<>"']*[^\s<>"',.])(?![^<]*<\/a>)/gm;
                return text.replace(urlRegex, function(url) {
                    url = url.replaceAll('&nbsp;','');
                    return '<a href="' + url + '" target="_blank" style="overflow-wrap: anywhere;color:#1d9bd1">' + url + '</a>';
                });
            }else{
                return ""
            } 
          },
          ...mapGetters("users", ["getLoggedInUser"]),
      },
    }
</script>
<style scoped>
    .scoped-rich-text-editor-content-display ::v-deep * {
        margin: revert;
        padding: revert;
     }
</style>